.signet-overlay {
  align-items: center;
  display: flex;
  visibility: hidden !important;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: auto;
  touch-action: none;
  opacity: 0;
  z-index: 99999;
  transition: all 0.3s ease-in-out;
  background-color: rgba(0, 0, 0, 0.2);

  &.opened {
    visibility: visible !important;
    opacity: 1;
    transition: all 0.3s ease-in-out;

    .content {
      transition: all 0.3s ease-in-out;
    }
  }

  &.absolute {
    position: absolute;
  }

  .scrim {
    border-radius: inherit;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    transition: inherit;
    width: 100%;
    will-change: opacity;
  }

  .content {
    position: relative;
    outline: none;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease-in-out;
  }
}
